module.exports = __webpack_public_path__ + "img/bat_yes.38faf3e3.png";